<template>
  <div class="text-center">
    <v-dialog
      v-model="dialog"
      width="500"
    >
      <template v-slot:activator="{ on }">

        <v-btn icon v-on="on">
          <v-icon>add</v-icon>
        </v-btn>
      </template>

      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          Search
        </v-card-title>

        <v-card-text>
          <select-project
            v-model="project"
            multiple
            show-select-all
          />
          <v-text-field hide-details v-model="search.account_id" label="ID" v-on:keyup.enter="handler" />
          <v-text-field hide-details v-model="search.login" label="Login" v-on:keyup.enter="handler" />
          <v-text-field hide-details v-model="search.email" label="Email" v-on:keyup.enter="handler" />
          <v-text-field hide-details v-model="search.phone" label="Phone" v-on:keyup.enter="handler" />
          <v-text-field hide-details v-model="search.name" label="Name" v-on:keyup.enter="handler" />
          <v-text-field hide-details v-model="search.surname" label="Surname" v-on:keyup.enter="handler" />
          <v-text-field hide-details v-model="search.ip" label="IP" v-on:keyup.enter="handler" />
          <v-text-field hide-details v-model="search.launch_login" label="Launch Login" v-on:keyup.enter="handler" />
        </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="primary"
            text
            @click="handler"
          >
            Search
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>


<script>
  import SelectProject from '@/components/core/SelectProject/SelectProject.vue'

  export default {
    components: { SelectProject },
    props: [ 'searchAccount' ],

    data: () => ({
      dialog: false,
      project: [],
      search: {
        fullsearch: true
      },
    }),

    watch: {
      dialog () {
        this.search = { fullsearch: true }
      }
    },

    methods: {
      handler: function (event) {
        this.dialog = false
        this.$emit('search', {
          ...this.search,
          by_entities: this.project,
        })
      }
    },

    emits: ['search'],
  }
</script>
